import {Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { SelectComponent } from '../select.component';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
  styleUrls: ['./select-item.component.less'],
})
export class SelectItemComponent implements OnInit,OnChanges {
  @Input() value: any;
  @Input() heading:any;
  @Input() isDisabled: boolean = false;
  @Input() customClass: string;
  @Input() counter:any;
  @Input() isStatus:boolean=false;
  @Input() customSelected:boolean = false;
  @Input() selected = false;
  @Input() icon:any;
  @Input() isContextMenu:boolean = false;
  @Input() item:any;
  @Input() count:any;
  @Input() searchValue:any;
  @Input() isContent:boolean = false;
  @Input() shortName:string;
  @Input() disableEllipsisTooltip:boolean=false;
  @Output() selectOptions: EventEmitter<any> = new EventEmitter();
  
    constructor(
      @Optional() private select: SelectComponent
    ) {}
  ngOnChanges(): void {
    if(this.value && this.heading){
      this.select.addSelectItem(this.value,this.heading,this.shortName);}
  }
  writeValue(obj: any): void {
   
  }
  registerOnChange(fn: () => {}): void {}

  registerOnTouched(fn: () => {}): void {}
  setDisabledState?(isDisabled: boolean): void {}
    public ngOnInit(): void {}
    
    selectOption(event?:any): void {
      if(!this.isContextMenu){
        this.select.changeItem(this.value,this.heading,this.shortName);
      }
      this.selectOptions.emit( event ? event : this.item)
    }

    checkboxSelect(event){
      this.selectOptions.emit(event)
    }
}


